import * as angular from 'angular';

import { MenuOptionId } from '@mode/legacy/types-app-state';
import { PlatformHeaderNavController, PlatformHeaderNavMenuType } from './platform-header-nav-controller';
import { DisplayMode } from '@mode/shared/contract-common';

const PlatformHeaderNavComponent: angular.IComponentOptions = {
  controller: PlatformHeaderNavController,
  controllerAs: 'ctrl',
  bindings: {
    account: '<',
    options: '<',
    defaultCommitMessageText: '<',
    displayMode: '<',
    expectedRuntime: '<',
    hasUnsyncedChanges: '<',
    hasUnsavedChanges: '<',
    lastSyncedAt: '<',
    mobileMenuIsOpen: '<',
    navType: '<',
    onDefinitionCreated: '&',
    onDefinitionUpdate: '&',
    onDefinitionDelete: '&',
    onNavItemClick: '&',
    onMobileMenuToggle: '&',
    onReportSpaceTransfer: '&',
    onRunReport: '&',
    onReportDeleted: '&',
    onSimpleShare: '&',
    onViewDetails: '&',
    onViewReport: '&',
    onSaveClick: '&',
    onSyncClick: '&',
    organizations: '<',
    owner: '<',
    report: '<',
    reportRun: '<',
    reportRunAt: '<',
    reportSpace: '<',
    selectedDefinition: '<',
    shareDialogData$: '<',
    staleRunAtEnabled: '<',
    dbtData: '<?',
    dbtDataLoading: '<?',
    referencedDatasources: '<',
    editAccess: '<',
    datasetLastRefreshed: '<',
    isTrialExpired: '<',
    datasetCount: '<?',
  },
  template: `
    <div class="platform-header-nav">
      <!-- Menu Begins -->
      <div ng-hide="ctrl.displayMode !== '${DisplayMode.Menu}'">
      <ul class="nav-list" ng-if="ctrl.navType === '${PlatformHeaderNavMenuType.Report}'">
        <!-- Visible Option Link Begins -->
        <!-- @todo move logic out of directives and handle in PlatformHeaderComponent -->
        <li class="nav-item"
            data-app-action-id="{{ctrl.resolveOption(option).get('id')}}"
            ng-repeat="option in ctrl.orderedVisibleOptionsArray track by ctrl.resolveOption(option).get('id')"
            ng-class="{disabled: !ctrl.resolveOption(option).isEnabled()}"
            ng-if="ctrl.resolveOption(option).isGranted()">

          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ViewDetails}')" ng-click="ctrl.handleViewDetailsClick($event)" data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ViewReport}')" ng-click="ctrl.handleViewReportClick($event)" data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="!ctrl.isTrialExpired && ctrl.optionIs(option, '${MenuOptionId.Report.Edit}')" ng-href="{{option.href}}" target="_self" data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <span class="nav-link" ng-if="ctrl.isTrialExpired && ctrl.optionIs(option, '${MenuOptionId.Report.Edit}')">
            <mode-promo-popover
              [is-trial-expired]="ctrl.isTrialExpired"
              [user-email]="(ctrl.account).email"
              [user-display-name]="(ctrl.account).displayName"
            >
              <span class="nav-link-text">{{ option.get('name') }}</span>
            </mode-promo-popover>
          </span>

          <a class="nav-link"
            ng-if="!ctrl.thoughtspotIntegrated && ctrl.optionIs(option, '${MenuOptionId.Report.Share}')"
            ng-click="ctrl.handleShare()"
            data-test="header-share-button"
            data-platform-header-menu-action
          >
            <span class="nav-link-text">
              {{ option.get('name') }}
            </span>
          </a>
          <a class="nav-link"
            ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.SimpleShare}')"
            ng-click="ctrl.handleSimpleShareClick($event)"
            data-platform-header-menu-action
          >
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Subscribe}')"
             schedules-modal
             report="ctrl.report"
             report-run="ctrl.reportRun"
             account="ctrl.account"
             owner="ctrl.owner"
             data-platform-header-menu-action
          >
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Clone}')"
             clone-modal
             account="ctrl.account"
             owner="ctrl.owner"
             report="ctrl.report"
             report-run="ctrl.reportRun"
             report-space="ctrl.reportSpace"
             current-context="{{ctrl.owner && ctrl.owner.token}}"
             clone-path="{{ctrl.getClonePath()}}"
             ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.CloneLoggedOut}')"
             clone-modal
             account="ctrl.account"
             report="ctrl.report"
             report-run="ctrl.reportRun"
             report-space="ctrl.reportSpace"
             current-context="{{ctrl.owner && ctrl.owner.token}}"
             logged-out="true"
             clone-path="{{ctrl.getClonePath()}}"
             ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Embed}')"
             embed-modal
             report="ctrl.report"
             report-run="ctrl.reportRun"
             owner="ctrl.owner"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Fullscreen}')" ng-click="ctrl.enterFullScreen()" data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ExportAll}')"
             ng-href="{{option.get('href')}}"
             target="_self"
             uib-tooltip="Export to CSV"
             tooltip-placement="bottom" data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>

          <!-- Nested Option Template Begins -->
          <div uib-dropdown dropdown-append-to-body class="nav-link-container" ng-if="ctrl.optionHasChildren(option)">
            <a uib-dropdown-toggle href="#" class="dropdown-toggle nav-link nav-link-dropdown" ng-click="ctrl.handleExportClick()">
              <span class="nav-link-text">{{ ctrl.getIndexOption(option).get('name') }}</span>
            </a>
            <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-left platform-header-more-menu">
              <li ng-repeat="childOption in ctrl.getChildrenOptionsAsArray(option)"
                  ng-class="{disabled: !childOption.isEnabled()}"
                  data-app-action-id="{{childOption.get('id')}}"
                  ng-if="childOption.isGranted()">
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.Export}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.ExportCsv}')"
                   target="_self"
                   ng-href="{{ childOption.get('href') }}"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.Export}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.ExportPdf}')"
                   pdf-export
                   report="ctrl.report"
                   report-run="ctrl.reportRun"
                   ng-click="ctrl.handlePdfExportClick()"
                   data-platform-header-menu-action
                  >
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.Export}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.ExportPdfDownload}')"
                   target="_self"
                   ng-href="{{ childOption.get('href') }}"
                   ng-class="{disabled: !childOption.isEnabled()}"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
              </li>
            </ul>
          </div>
          <!-- @Nested Option Template Ends-->

        </li>
        <!-- @Visible Option Ends -->

        <li uib-dropdown dropdown-append-to-body class="nav-item dropdown" ng-if="ctrl.orderedOverflowOptions.size" is-open="dropOpen">
          <a uib-dropdown-toggle href="#" class="dropdown-toggle nav-link nav-link-dropdown" data-test="more-header-dropdown-menu">
            <span class="nav-link-text">More</span>
          </a>
          <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-left platform-header-more-menu">
            <li ng-repeat="option in ctrl.orderedOverflowOptionsArray"
                ng-class="{disabled: !option.isEnabled()}"
                data-app-action-id="{{option.get('id')}}"
                ng-if="option.isGranted()">

              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Clone}')"
                 clone-modal
                 account="ctrl.account"
                 owner="ctrl.owner"
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 report-space="ctrl.reportSpace"
                 current-context="{{ctrl.owner && ctrl.owner.token}}"
                 clone-path="{{ctrl.getClonePath()}}"
                 data-test="clone-report-link"
                 ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this"
                 data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.CloneLoggedOut}')"
                 clone-modal
                 account="ctrl.account"
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 report-space="ctrl.reportSpace"
                 current-context="{{ctrl.owner && ctrl.owner.token}}"
                 logged-out="true"
                 clone-path="{{ctrl.getClonePath()}}"
                 ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this"
                 data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="!ctrl.thoughtspotIntegrated && ctrl.optionIs(option, '${MenuOptionId.Report.Embed}')"
                 embed-modal
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 owner="ctrl.owner"
                 data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Fullscreen}')" ng-click="ctrl.enterFullScreen()"
              data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>

            </li>
          </ul>
        </li>
        <li class="nav-item nav-divider" ng-if="ctrl.reportRunAt">
          <span class="nav-divider">&bullet;</span>
        </li>
        <li class="nav-item" ng-if="ctrl.reportRunAt">
          <span>
            Refreshed
            <mode-time-ago [date]="ctrl.reportRunAt">
            </mode-time-ago>
          </span>
        </li>
        <li class="nav-item">
          <mode-metadata-popover
            [number-of-views]="ctrl.dbtData.views"
            [last-edit]="ctrl.dbtData.lastEdit"
            [last-successful-run]="ctrl.dbtData.lastSuccessfulRun"
            [dbt-tables]="ctrl.dbtData.tables"
            [dbt-source-last-load-time]="ctrl.dbtData.sourceDataLastLoadedAt"
            [dbt-status]="ctrl.dbtData.state"
            [dbt-message]="ctrl.dbtData.message"
            [dbt-data-loading]="ctrl.dbtDataLoading"
            [referenced-datasources]="ctrl.referencedDatasources"
            [user-can-edit-report]="ctrl.editAccess"
            [dataset-last-refreshed]="ctrl.datasetLastRefreshed"
          ></mode-metadata-popover>
        </li>

        <li class="nav-item" ng-if="!ctrl.isTrialExpired && ctrl.options.get('${MenuOptionId.Report.Refresh}').isGranted()" data-app-action-id="{{ctrl.options.get('${MenuOptionId.Report.Run}').get('id')}}">
          <capra-tooltip
            class="tooltip-pre-wrap"
            tooltip-content="{{ ctrl.refreshButtonTooltipCopy(ctrl.options.get('${MenuOptionId.Report.Refresh}').isEnabled(), ctrl.dataViewFacade.importedDatasetCount$ | async, ctrl.dataViewFacade.localSwitchViewCount$ | async) }}"
            tooltip-placement="bottom"
            >
            <button
              class="refresh-button"
              ng-disabled="!ctrl.options.get('${MenuOptionId.Report.Refresh}').isEnabled() || ctrl.disableRefreshButton"
              ng-click="ctrl.handleRunReportClick($event)"
              data-test="refresh-button"
              data-platform-header-menu-action
            >
              <capra-icon
              class="data-refresh-icon"
              icon="icon-data-refresh"
              width="16px"
              height="16px"
              ></capra-icon>
              <span class="data-refresh-copy">{{ ctrl.options.get('${MenuOptionId.Report.Refresh}').get('name') }}</span>
            </button>
          </capra-tooltip>
        </li>

        <li class="nav-item" ng-if="ctrl.isTrialExpired">
          <mode-promo-popover
            [is-trial-expired]="ctrl.isTrialExpired"
            [user-email]="(ctrl.account).email"
            [user-display-name]="(ctrl.account).displayName"
          >
            <span class="nav-link-text">{{ ctrl.options.get('${MenuOptionId.Report.Run}').get('name') }}</span>
          </mode-promo-popover>
        </li>
      </ul>

      <!-- TODO Consider making this a separate component -->
      <ul class="nav-list" ng-if="ctrl.navType === '${PlatformHeaderNavMenuType.Editor}'">
        <!-- Visible Option Link Begins -->
        <!-- @todo move logic out of directives and handle in PlatformHeaderComponent -->
        <li class="nav-item"
          data-app-action-id="{{ctrl.resolveOption(option).get('id')}}"
          data-test="{{ctrl.resolveOption(option).get('id')}}"
          ng-repeat="option in ctrl.orderedVisibleOptionsArray track by ctrl.resolveOption(option).get('id')"
          ng-class="{disabled: !ctrl.resolveOption(option).isEnabled()}"
          ng-if="ctrl.resolveOption(option).isGranted()"
        >
          <a class="nav-link"
            data-platform-header-menu-action
            data-test="view-report-details-link"
            ng-href="{{ ctrl.report.share }}/details"
            ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ViewDetails}')"
            rel="noopener"
            report="ctrl.report"
            save-report-alert
            target="_blank"
          >
            <span class="nav-link-text">View details</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ViewReport}')"
             save-report-alert
             report="ctrl.report"
             ng-href="{{ ctrl.report.share }}"
             target="_blank"
             data-test="view-report-link"
             rel="noopener"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link"
            ng-if="!ctrl.thoughtspotIntegrated && ctrl.optionIs(option, '${MenuOptionId.Report.Share}')"
            ng-click="ctrl.handleShare()"
            data-test="header-share-button"
            data-platform-header-menu-action
          >
            <span class="nav-link-text">
              {{ option.get('name') }}
            </span>
          </a>
          <a class="nav-link" ng-if="!ctrl.thoughtspotIntegrated && ctrl.optionIs(option, '${MenuOptionId.Report.Embed}')"
             embed-modal
             report="ctrl.report"
             report-run="ctrl.reportRun"
             owner="ctrl.owner"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Schedule}')"
             schedules-modal
             report="ctrl.report"
             report-run="ctrl.reportRun"
             owner="ctrl.owner"
             account="ctrl.account"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <!-- Nested Option Template Begins -->
          <div uib-dropdown dropdown-append-to-body class="nav-link-container" ng-if="ctrl.optionHasChildren(option)">
            <a uib-dropdown-toggle href="#" class="dropdown-toggle nav-link nav-link-dropdown" data-test="report-header-dropdown-menu">
              <span class="nav-link-text">{{ ctrl.getIndexOption(option).get('name') }}</span>
            </a>
            <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-left platform-header-more-menu">
              <li ng-repeat="childOption in ctrl.getChildrenOptionsAsArray(option)"
                  ng-class="{disabled: ctrl.isDisabledOption(childOption)}"
                  data-app-action-id="{{childOption.get('id')}}"
                  ng-if="childOption.isGranted()">
                <hr class="section-divider"
                  ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && (ctrl.optionIs(childOption, '${MenuOptionId.Report.Move}') || ctrl.optionIs(childOption, '${MenuOptionId.Report.Delete}'))"
                />
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.Clone}')"
                   clone-modal
                   account="ctrl.account"
                   owner="ctrl.owner"
                   report="ctrl.report"
                   report-run="ctrl.reportRun"
                   report-space="ctrl.reportSpace"
                   current-context="{{ctrl.owner && ctrl.owner.token}}"
                   clone-path="{{ctrl.getClonePath()}}"
                   data-test="{{childOption.get('name') | lowercase }}-report-link"
                   ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.Delete}')"
                   mode-delete-report
                   on-report-deleted="ctrl.handleReportDeleted($reportToken)"
                   report="ctrl.report"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="!ctrl.thoughtspotIntegrated && ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.Settings}')"
                   report-settings-modal
                   report="ctrl.report"
                   owner="ctrl.owner"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.Rename}')"
                   rename-report
                   is-report-state="ctrl.reportStateEnabled$ | async:this"
                   report="ctrl.report"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.Move}')"
                   move-space
                   report="ctrl.report"
                   account="ctrl.accountFacade.user$ | async:this"
                   owner="ctrl.reportOwnerWithSpaces$ | async:this"
                   on-report-space-update="ctrl.handleReportSpaceTransfer($space, isViaPublishAction, switchViewToken)"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.Save}')"
                   ng-click="ctrl.handleSave()"
                   data-platform-header-menu-action>
                  <span class="hotkey">Ctrl/Cmd-S</span><span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.Sync}')"
                  ng-click="ctrl.handleReportGithubSync()"
                  data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link"
                   ng-href="{{childOption.href}}"
                   ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.ViewGithub}')"
                   target="_blank"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
                <a class="nav-more-link" ng-if="ctrl.optionIs(ctrl.getIndexOption(option), '${MenuOptionId.Report.ManageReport}') && ctrl.optionIs(childOption, '${MenuOptionId.Report.CreateShortcut}')"
                   shortcut-space
                   report="ctrl.report"
                   space="ctrl.reportSpace"
                   account="ctrl.accountFacade.user$ | async:this"
                   owner="ctrl.reportOwnerWithSpaces$ | async:this"
                   data-platform-header-menu-action>
                  <span class="nav-link-text">{{ childOption.get('name') }}</span>
                </a>
              </li>
            </ul>
          </div>
          <!-- @Nested Option Template Ends-->

        </li>
        <!-- @Visible Option Ends -->

        <li uib-dropdown dropdown-append-to-body class="nav-item dropdown" ng-if="ctrl.orderedOverflowOptions.size" is-open="dropOpen">
          <a uib-dropdown-toggle href="#" class="dropdown-toggle nav-link nav-link-dropdown">
            <span class="nav-link-text">More</span>
          </a>
          <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-left platform-header-more-menu">
            <li ng-repeat="option in ctrl.orderedOverflowOptionsArray"
                ng-class="{disabled: !option.isEnabled()}"
                data-app-action-id="{{option.get('id')}}"
                ng-if="option.isGranted()">

              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Clone}')"
                 clone-modal
                 account="ctrl.account"
                 owner="ctrl.owner"
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 report-space="ctrl.reportSpace"
                 current-context="{{ctrl.owner && ctrl.owner.token}}"
                 clone-path="{{ctrl.getClonePath()}}"
                 ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this"
                 data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Embed}')"
                 embed-modal
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 owner="ctrl.owner"
                 data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Fullscreen}')" ng-click="ctrl.enterFullScreen()">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item nav-divider" ng-if="ctrl.options.get('${MenuOptionId.Report.Sync}').isGranted()">
          <span class="nav-divider">•</span>
        </li>
        <li class="nav-item" ng-if="ctrl.options.get('${MenuOptionId.Report.Sync}').isGranted()">
        <mode-github-sync-indicator
          [last-synced-at]="ctrl.lastSyncedAt"
          [has-unsynced-changes]="ctrl.hasUnsyncedChanges"
          content-type="report"
          github-sync-menu-name="Report">
        </mode-github-sync-indicator>
        </li>
      </ul>

      <!-- TODO Consider making this a separate component -->
      <ul class="nav-list" ng-if="ctrl.navType === '${PlatformHeaderNavMenuType.DefinitionEditor}'">
        <li class="nav-item"
            ng-repeat="option in ctrl.orderedVisibleOptionsArray track by option.get('id')"
            ng-class="{disabled: !option.isEnabled()}"
            data-app-action-id="{{option.get('id')}}"
            ng-if="option.isGranted()">

          <!-- Visible Option Link Begins -->
          <!-- @todo move logic out of directives and handle in PlatformHeaderComponent -->
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Definition.Create}')"
             create-definition
             modal-confirm="ctrl.handleDefinitionCreated($definition)"
             owner="ctrl.owner"
             account="ctrl.account"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Definition.Settings}')"
             rename-definition="ctrl.selectedDefinition"
             account="ctrl.owner"
             modal-title="Manage Definition"
             modal-confirm="ctrl.handleDefinitionUpdate($definition)"
             data-platform-header-menu-action>
            <span class="nav-link-text">{{ option.get('name') }}</span>
          </a>
          <!-- @Visible Option Ends -->

        </li>

        <li uib-dropdown dropdown-append-to-body class="nav-item dropdown" ng-if="ctrl.orderedOverflowOptions.size" is-open="dropOpen">
          <a uib-dropdown-toggle href="#" class="dropdown-toggle nav-link nav-link-dropdown">
            <span class="nav-link-text">More</span>
          </a>
          <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-left platform-header-more-menu">
            <li ng-repeat="option in ctrl.orderedOverflowOptionsArray"
                ng-class="{disabled: !option.isEnabled()}"
                data-app-action-id="{{option.get('id')}}"
                ng-if="option.isGranted()">
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Definition.Sync}')"
                ng-click="ctrl.handleDefinitionGithubSync()"
                data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Definition.ViewGithub}')"
                 ng-href="{{ option.get('href') }}"
                 target="_blank"
                 data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Definition.Delete}')"
                 confirm-modal="Are you sure you want to delete definition {{ ctrl.selectedDefinition.name }}?"
                 confirm-modal-on-confirm="ctrl.handleDefinitionDelete($event)"
                 confirm-modal-button-class="btn-error"
                 confirm-modal-button-confirm="Delete Definition"
                 confirm-modal-button-cancel="Close"
                 confirm-modal-title="Delete Definition"
                 data-platform-header-menu-action>
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item nav-divider" ng-if="ctrl.options.get('${MenuOptionId.Definition.Sync}').isGranted()">
          <span class="nav-divider">•</span>
        </li>
        <li class="nav-item" ng-if="ctrl.options.get('${MenuOptionId.Definition.Sync}').isGranted()">
          <mode-github-sync-indicator
            [last-synced-at]="ctrl.lastSyncedAt"
            [has-unsynced-changes]="false"
            content-type="definition"
            github-sync-menu-name="More">
          </mode-github-sync-indicator>
        </li>
      </ul>
      </div>
      <!-- @Menu Ends -->

      <!-- Dropdown Begins -->
      <div ng-if="ctrl.displayMode === '${DisplayMode.Dropdown}'">
        <div uib-dropdown
            dropdown-append-to-body
            class="nav-item dropdown"
            ng-if="ctrl.orderedDropdownOptions.size"
            is-open="ctrl.mobileMenuIsOpen"
            on-toggle="ctrl.handleMobileMenuToggle(open)">
          <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-left platform-header-mobile-menu">
            <li ng-repeat="option in ctrl.orderedDropdownOptionsArray"
                ng-class="{disabled: ctrl.isDisabledOption(option)}"
                data-app-action-id="{{ctrl.resolveOption(option).get('id')}}"
                ng-if="ctrl.resolveOption(option).isGranted()">
              <a class="nav-link"
                 ng-click="ctrl.mobileMenuClicked($event, ctrl.resolveOption(option).get('id'))"
                 ng-if="!ctrl.isInlineMobileOption(ctrl.resolveOption(option))">
                <span class="nav-link-text" ng-if="!ctrl.optionHasChildren(option)">{{ option.get('name') }}</span>
              </a>

              <!-- Temporary Mobile Menu Items Begin -->
              <!-- @todo (Franklin): refactor to prevent this duplication https://app.asana.com/0/0/497047490591455 -->
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Embed}')"
                 embed-modal
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 owner="ctrl.owner">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Fullscreen}')" ng-click="ctrl.enterFullScreen()">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Clone}')"
                 clone-modal
                 account="ctrl.account"
                 owner="ctrl.owner"
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 report-space="ctrl.reportSpace"
                 current-context="{{ctrl.owner && ctrl.owner.token}}"
                 clone-path="{{ctrl.getClonePath()}}"
                 ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.CloneLoggedOut}')"
                 clone-modal
                 account="ctrl.account"
                 report="ctrl.report"
                 report-run="ctrl.reportRun"
                 report-space="ctrl.reportSpace"
                 current-context="{{ctrl.owner && ctrl.owner.token}}"
                 logged-out="true"
                 clone-path="{{ctrl.getClonePath()}}"
                 ng-disabled="ctrl.isReportCloneInProgress$(ctrl.report.token) | async:this">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Delete}')"
                 mode-delete-report
                 on-report-deleted="ctrl.handleReportDeleted($reportToken)"
                 report="ctrl.report">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Settings}')"
                 report-settings-modal
                 report="ctrl.report"
                 owner="ctrl.owner">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Rename}')"
                 rename-report
                 is-report-state="ctrl.reportStateEnabled$ | async:this"
                 report="ctrl.report">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Move}')"
                 move-space
                 report="ctrl.report"
                 account="ctrl.accountFacade.user$ | async:this"
                 owner="ctrl.reportOwnerWithSpaces$ | async:this"
                 on-report-space-update="ctrl.handleReportSpaceTransfer($space, isViaPublishAction, switchViewToken)"
                 >
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Save}')"
                ng-click="ctrl.handleSave()">
                <span class="hotkey">Ctrl/Cmd-S</span><span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ViewGithub}') || ctrl.optionIs(option, '${MenuOptionId.Definition.ViewGithub}')"
                ng-href="{{option.href}}"
                target="_blank">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.CreateShortcut}')"
                 shortcut-space
                 report="ctrl.report"
                 space="ctrl.reportSpace"
                 account="ctrl.accountFacade.user$ | async:this"
                 owner="ctrl.reportOwnerWithSpaces$ | async:this">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link"
                ng-if="ctrl.navType === '${PlatformHeaderNavMenuType.Editor}' && ctrl.optionIs(option, '${MenuOptionId.Report.ViewDetails}')"
                save-report-alert
                report="ctrl.report"
                ng-href="{{ ctrl.report.share }}/details"
                target="_blank"
                rel="noopener">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.navType === '${PlatformHeaderNavMenuType.Editor}' && ctrl.optionIs(option, '${MenuOptionId.Report.ViewReport}')"
                 save-report-alert
                 report="ctrl.report"
                 ng-href="{{ ctrl.report.share }}"
                 target="_blank"
                 rel="noopener">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <!-- @Temporary Editor Mobile Menu Items End -->

              <!-- Temporary Report Mobile Menu Items Begin -->
              <!-- @todo (Franklin): refactor to prevent this duplication https://app.asana.com/0/0/497047490591455 -->
              <a class="nav-link" ng-if="ctrl.navType === '${PlatformHeaderNavMenuType.Report}' && ctrl.optionIs(option, '${MenuOptionId.Report.ViewReport}')" ng-click="ctrl.handleViewReportClick($event)">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.Edit}')" ng-href="{{option.href}}" target="_self">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ExportCsv}')"
                 target="_self"
                 ng-href="{{ option.get('href') }}">
                <span class="nav-link-text">{{ childOption.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ExportPdf}')"
                  pdf-export
                  report="ctrl.report"
                  report-run="ctrl.reportRun">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <a class="nav-more-link" ng-if="ctrl.optionIs(option, '${MenuOptionId.Report.ExportPdfDownload}')"
                 target="_self"
                 ng-href="{{ option.get('href') }}"
                 ng-class="{disabled: !option.isEnabled()}">
                <span class="nav-link-text">{{ option.get('name') }}</span>
              </a>
              <!-- @Temporary Report Mobile Menu Items End -->

            </li>
          </ul>
        </div>

      </div>
      <!-- @Dropdown Ends -->
    </div>
  `,
};

export { PlatformHeaderNavComponent };

// @todo remove by registering explicitly at the application/module level for portability
angular.module('mode.components').component('platformHeaderNav', PlatformHeaderNavComponent);
